import DashboardLayout from '../../core/Layout/Layout.jsx';
import {RumDashboardMain} from '../Dashboard404Report/Dashboard404ReportMain.jsx';

const Dashboard404Report = () => (
  <DashboardLayout>
      <RumDashboardMain></RumDashboardMain>
  </DashboardLayout>
);

export default Dashboard404Report;
